import { GetAgentNotice, SaveAgentNotice, DelNotice, GetUpdateNotice, EditUpdateNotice, GetNoticeList, GetNoticeDetail, DeleteNotice, EditNotice, GetNoticeCount, MsgPush } from '@/api/notice'
export default {
  state: {

  },
  actions: {
    GetAgentNotice ({ commit }, payload) {
      return new Promise(resolve => {
        GetAgentNotice(payload).then(res => {
          resolve(res.data)
        })
      })
    },
    SaveAgentNotice ({ commit }, payload) {
      return new Promise(resolve => {
        SaveAgentNotice(payload).then(res => {
          resolve(res.data)
        })
      })
    },
    DelNotice ({ commit }, payload) {
      return new Promise(resolve => {
        DelNotice(payload).then(res => {
          resolve(res.data)
        })
      })
    },
    GetUpdateNotice ({ commit }, payload) {
      return new Promise(resolve => {
        GetUpdateNotice(payload).then(res => {
          resolve(res.data)
        })
      })
    },
    EditUpdateNotice ({ commit }, payload) {
      return new Promise(resolve => {
        EditUpdateNotice(payload).then(res => {
          resolve(res.data)
        })
      })
    },
    GetNoticeList ({ commit }, payload) {
      return new Promise(resolve => {
        GetNoticeList(payload).then(res => {
          resolve(res.data)
        })
      })
    },
    GetNoticeDetail ({ commit }, payload) {
      return new Promise(resolve => {
        GetNoticeDetail(payload).then(res => {
          resolve(res.data)
        })
      })
    },
    DeleteNotice ({ commit }, payload) {
      return new Promise(resolve => {
        DeleteNotice(payload).then(res => {
          resolve(res.data)
        })
      })
    },
    EditNotice ({ commit }, payload) {
      return new Promise(resolve => {
        EditNotice(payload).then(res => {
          resolve(res.data)
        })
      })
    },
    GetNoticeCount ({ commit }, payload) {
      return new Promise(resolve => {
        GetNoticeCount(payload).then(res => {
          resolve(res.data)
        })
      })
    },
    MsgPush ({ commit }, payload) {
      return new Promise(resolve => {
        MsgPush(payload).then(res => {
          resolve(res.data)
        })
      })
    }

  },
  getters: {

  },
  mutations: {

  }
}
